import { Type } from 'lucide-react';
import { cn } from '../../../lib/utils';
import { EYEBROW, FOCUS_RING, PILL_INK, TEXT_PRESETS, TEXT_STYLES } from '../constants';
import { PanelHeading } from '../controls';

/** Text tool: add text boxes and apply text combinations. */
export const TextPanel = ({ onAddText, onApplyPreset, textSelected }) => (
  <div className="flex flex-col gap-3.5">
    <PanelHeading>Text</PanelHeading>
    <button
      type="button"
      onClick={() => onAddText({ text: 'Your text', font_size: 32 })}
      className={cn(PILL_INK, 'h-[46px] text-[15px] font-extrabold')}
      data-testid="add-text-btn"
    >
      <Type className="h-[18px] w-[18px]" aria-hidden="true" />
      Add a text box
    </button>

    <p className={EYEBROW}>Default text styles</p>
    <div className="flex flex-col gap-2">
      {TEXT_STYLES.map((s) => (
        <div key={s.id} className="flex items-stretch rounded-xl border border-[#E6E1D6] overflow-hidden">
          <button
            type="button"
            onClick={() => onAddText({ ...s.field, text: s.text.en, label: s.label.replace('Add a ', '').replace('Add ', '') })}
            className={cn('flex-1 text-left px-3.5 py-2.5 hover:bg-cream', s.className, FOCUS_RING)}
            data-testid={`add-${s.id}`}
          >
            {s.label}
          </button>
          <button
            type="button"
            dir="rtl"
            onClick={() => onAddText({ ...s.field, text: s.text.he, label: s.label.replace('Add a ', '').replace('Add ', '') })}
            aria-label={`${s.label} in Hebrew`}
            className={cn('px-3 font-hebrew text-[13px] text-[#6B665C] hover:bg-cream hover:text-ink border-l border-[#EEEBE4]', FOCUS_RING)}
          >
            {s.hebrew}
          </button>
        </div>
      ))}
    </div>

    <div className="flex justify-between items-baseline">
      <p className={EYEBROW}>Text combinations</p>
      <p className="text-[11px] text-[#6B665C]">{textSelected ? 'Click to apply' : 'Click to add'}</p>
    </div>
    <div className="grid grid-cols-2 gap-2">
      {TEXT_PRESETS.map((p) => (
        <button
          key={p.id}
          type="button"
          onClick={() => onApplyPreset(p)}
          aria-label={`${p.name}${textSelected ? ': apply to selected text' : ': add styled text'}`}
          title={p.name}
          className={cn('h-[74px] rounded-xl flex items-center justify-center px-1.5 overflow-hidden hover:opacity-90', FOCUS_RING)}
          style={p.tile}
          data-testid={`preset-${p.id}`}
        >
          <span dir="rtl" style={p.sampleStyle} className="whitespace-nowrap">
            {p.sample}
          </span>
        </button>
      ))}
    </div>
  </div>
);

export default TextPanel;
